import React from 'react';

import CompleteProfileProfessionsForm from '../forms/CompleteProfileProfessionsForm'


class CompleteProfileStep1 extends React.Component {

    constructor(props) {
        super(props);
    }

    submit(e) {
        e.preventDefault();

        const data = this.refs.form.getValue();
        const errors = this.refs.form.validate(true).errors;
        if (Object.keys(errors).length) {
            this.props.mergeErrorsIntoState(errors);
        } else if (Object.keys(data).length) {
            this.props.addData(data);
            this.props.mergeErrorsIntoState({});
            this.props.changeStep.call(this, 2, true);
        }
    }

    render () {
        const positions = this.props.positions;
        const errors = this.props.errors;
        if (positions.length == 0) {
            return (
                <div className="complete-profile-step-content complete-profile-step1">
                    <div className="spinner">
                      <div className="double-bounce1"></div>
                      <div className="double-bounce2"></div>
                    </div>
                </div>
            );
        }

        return (
            <div className="complete-profile-step-content complete-profile-step1">
                <div className="info">You can have multiple professions. Choose one when applying for a shift.</div>
                <form onSubmit={this.submit.bind(this)} noValidate>
                    <CompleteProfileProfessionsForm positions={positions} errors={errors} ref="form" />

                    <div>
                        <button className="btn btn-small btn-green" type="submit">Continue</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default CompleteProfileStep1;



/** WEBPACK FOOTER **
 ** ./app/src/components/CompleteProfileStep1.js
 **/